import { Navigate, useRoutes } from 'react-router-dom';
import Layout from 'src/layouts/Layout';

// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
import CompactLayout from '../layouts/compact';
// layouts
import SimpleLayout from '../layouts/simple';

//
import {
  ComingSoon,
  Home,
  Login,
  Maintenance,
  Management,
  MyInfo,
  Page403,
  Page404,
  Page500,
} from './elements';
import { PATH_AUTH, PATH_ROOT } from './paths';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <Layout />
        </AuthGuard>
      ),
      children: [{ element: <Home />, index: true }],
    },
    // {
    //   element: <SimpleLayout />,
    //   children: [
    //     {
    //       path: '/',
    //       element: (
    //         <GuestGuard>
    //           <Login />
    //         </GuestGuard>
    //       ),
    //     },
    //   ],
    // },
    {
      path: PATH_AUTH.login,
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    // Main Routes
    {
      element: (
        <AuthGuard>
          <Layout />
        </AuthGuard>
      ),
      children: [
        { element: <Home />, index: true },
        {
          path: PATH_ROOT.monthlyReport.root,
          element: <Home />,
        },
        {
          path: PATH_ROOT.monitoring.root,
          element: <ComingSoon />,
        },
        {
          path: PATH_ROOT.myInfo.root,
          element: <MyInfo />,
        },
        {
          path: PATH_ROOT.management.root,
          children: [
            { path: 'infra-image', element: <Management type={'infraImage'} /> },
            { path: 'service', element: <Management type={'service'} /> },
            { path: 'accVmIp', element: <Management type={'accVmIp'} /> },
            { path: 'infra', element: <Management type={'infra'} /> },

            // { path: 'user', element: <Management type={'user'} />, index: true },
            // { path: 'permission', element: <Management type={'permission'} /> },
            // { path: 'group', element: <Management type={'group'} /> },
            // { path: 'menu', element: <Management type={'menu'} /> },
            // { path: 'dept', element: <Management type={'dept'} /> },
            // { path: 'setting', element: <Management type={'setting'} /> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: '403', element: <Page403 /> },
        { path: '404', element: <Page404 /> },
        { path: '500', element: <Page500 /> },
        { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'maintenance', element: <Maintenance /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
